import { TextStyle } from '@ticketmaster/global-design-system';
import { getEventDateRange, getEventStartLocalDateTime } from '../helpers/moment/moment.utils';
import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import { T } from '@/v2/helpers/i18n';
import { EventModel } from '@/v2/models/eventModel';
import styles from './eventTicketsHeader.module.scss';
import { HEADER_TITLE } from '@/v2/header/header.constants.ts';

type Props = {
  event: EventModel
} & T;

const EventTicketsHeader = ({ event, t }: Props) => {
  return (
    <div className={styles.eventTicketsHeader}>
      <TextStyle.Boising className={styles.eventName}>
        {event ? event.title : t(HEADER_TITLE)}
      </TextStyle.Boising>

      {event && (
        <>
          <TextStyle.Etna className={styles.eventTicketsHeaderDetails}>
            {!!event.dateRange && getEventDateRange(event.dateRange)}
            {!event.dateRange && !!event.startLocalDate && getEventStartLocalDateTime(event.startLocalDate, event.startLocalTime)}
            {!event.dateRange && !event.startLocalDate && t('WALLET.INFO.TBA')}
          </TextStyle.Etna>
          <TextStyle.Etna className={styles.eventTicketsHeaderDetails}>
            {event.venue?.title?.replace(/\sat\s/, ' @ ')}&nbsp;-&nbsp;{event.venue?.city}
          </TextStyle.Etna>
        </>
      )}
    </div>
  );
};

export default withTranslation('translation')(memo(EventTicketsHeader));
